import React from 'react';
import { Button } from './Button';
import { checkoutUrl, ctaLabelSystem, finalIncludedItems, trackCheckout } from '../data/offer';
const noMoreItems = ['No more Sunday evenings searching for technical progressions that actually work', 'No more classes that feel rushed or improvised', 'No more students losing motivation because sessions feel repetitive', 'No more weekends lost planning instead of living', 'No more walking onto the mat wishing you had prepared more'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-navy-deep text-white relative overflow-hidden" data-id="element-111" data-mp="h5c7pkx25q6s">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-112" data-mp="vtgh1ya80pcw">
        <div className="text-center mb-16" data-id="element-113" data-mp="qvotfgglzpei">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-114" data-mp="qwzs51v766yr">
            Next Monday you can keep building your lessons from scratch...
            <br data-id="element-115" data-mp="zwmt5mk0lara" />
            <span className="text-gold-light" data-id="element-116" data-mp="zx4sis1z453f">
              Or you can walk onto the mat with everything ready — starting
              today.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-117" data-mp="2h3hm0hb8ek2o">
            {noMoreItems.map(item => <div key={item} className="flex items-start gap-3" data-id="element-118" data-mp="2m4x9sh4sn4or">
                <span className="text-gold mt-1" aria-hidden="true" data-id="element-119" data-mp="2r2p1ba1j0osf">
                  ▸
                </span>
                <span className="text-white/80" data-id="element-120" data-mp="2v2zgndb7krjy">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-121" data-mp="300soeas5ttmc">
            Brazilian Jiu-Jitsu Instructor Ready does not make you a better
            instructor.
          </p>
          <p className="text-2xl font-bold text-gold-light mb-6" data-id="element-122" data-mp="39sop7tlmrxu9">
            You are already a great instructor.
          </p>
          <p className="text-xl text-white/80 mb-16" data-id="element-123" data-mp="3et2skycaejly">
            What BJJ Instructor Ready does is give you the time and the tools to
            make that visible in every single class you teach.
          </p>
        </div>

        <div className="bg-cream-card border-2 border-gold rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-124" data-mp="1jlz3q7axjrq1">
          <h3 className="text-2xl font-bold text-navy-deep mb-6 text-center border-b border-gold-light pb-6 font-serif" data-id="element-125" data-mp="1enfg82gou7vk">
            Everything included in the 6-in-1 system:
          </h3>

          <p className="text-xs text-warmgray mb-3 text-center md:hidden" data-id="element-126" data-mp="1nnu6lg8ied5x">
            ← Scroll to see full table →
          </p>
          <div className="overflow-x-auto mb-10" data-id="element-127" data-mp="1xg0578t9nsu3">
            <table className="w-full text-sm min-w-[460px] border border-gold-light rounded-xl overflow-hidden" data-id="element-128" data-mp="1xf8dwa6pch9m">
              <thead data-id="element-129" data-mp="2bdf02t2agstg">
                <tr className="bg-navy-deep text-white" data-id="element-130" data-mp="27dxsnu3axlln">
                  <th scope="col" className="text-left font-bold px-4 py-3" data-id="element-131" data-mp="27efmkk2hrnqe">
                    Content
                  </th>
                  <th scope="col" className="text-right font-bold px-4 py-3 w-28" data-id="element-132" data-mp="h3bck7n2rt2p">
                    Included
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-133" data-mp="2wrkuoj0l5d3">
                {finalIncludedItems.map(item => <tr key={item} className="border-b border-gold-light last:border-b-0" data-id="element-134" data-mp="6w9tolxk9pzk">
                    <td className="px-4 py-3 text-ink" data-id="element-135" data-mp="3pahpdbdqhex7">{item}</td>
                    <td className="px-4 py-3 text-right text-forest" data-id="element-136" data-mp="3uani6uvqp7gv">✅</td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center" data-id="element-137" data-mp="3ffhe4dg7fiq6">
            <div className="mb-8 p-6 bg-cream-beige rounded-xl border border-gold-light italic text-ink text-lg" data-id="element-138" data-mp="3kcze3ec8unm1">
              &quot;The best time to have this complete teaching system was
              before your very first BJJ class.
              <br data-id="element-139" data-mp="3bcba7cgke3mv" />
              <span className="text-gold font-bold not-italic" data-id="element-140" data-mp="3bdvtu71cc25y">
                The second best time is today.
              </span>
              &quot;
            </div>
            <p className="text-xl font-serif font-bold text-navy-deep mb-2" data-id="element-141" data-mp="19j3mpfqssfpw">
              📚 Brazilian Jiu-Jitsu Instructor Ready — Complete 6-in-1 Teaching
              System
            </p>
            <p className="text-sm text-warmgray mb-8" data-id="element-142" data-mp="30pro1vn5e7k7">
              100 BJJ lessons ready to teach — designed to help instructors plan
              less, teach with confidence and keep every session truly
              structured and fresh.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-143" data-mp="2mof7pj42s3xs">
              {ctaLabelSystem}
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-warmgray" data-id="element-144" data-mp="2czf9w31b7el6">
              <span data-id="element-145" data-mp="281401sb0l42y">✅ 7-Day Money Back Guarantee</span>
              <span data-id="element-146" data-mp="23xxt0ig2v8vf">✅ Secure Payment</span>
              <span data-id="element-147" data-mp="23ww9dpkzxe23">✅ Immediate Access</span>
              <span data-id="element-148" data-mp="1yz4dyll579t5">✅ Pay in Your Local Currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}